// extracted by mini-css-extract-plugin
export var button = "_dy-4";
export var hasDarkBackground = "_dy-7";
export var hasLightBackground = "_dy-6";
export var iconWrapper = "_dy-0";
export var large = "_dy-2";
export var medium = "_dy-1";
export var small = "_dy-5";
export var xsmall = "_dy-3";